const state = {
  locale: 'de-DE',
  localeShort: 'de',
  country: 'DE',
  localMessages: {},
  dateFormat: 'DD MMM YY',
  dateFormatCalendar: 'd M y',
  timeFormat: 'HH:mm',
  currency: '€'
}

const getters = {
  getLocale: state => {
    return state.locale
  },
  getLocaleShort: state => {
    return state.localeShort
  },
  getCountry: state => {
    return state.country
  },
  getLocaleMessages: state => {
    return state.localMessages
  },
  getDateFormat: state => {
    return state.dateFormat
  },
  getTimeFormat: state => {
    return state.timeFormat
  },
  getDateFormatCalendar: state => {
    return state.dateFormatCalendar
  },
  getCurrency: state => {
    return state.currency
  }
}

const mutations = {
  updateLocale: (state, locale) => {
    state.locale = locale
    let localeArray = locale.split('-')
    state.localeShort = localeArray[0]
    state.country = localeArray[1]
  },
  updateLocaleMessages: (state, localeMessages) => {
    state.localMessages = localeMessages
  },
  updateDateFormat: (state, locale) => {
    switch (locale) {
      case 'en-US':
        state.timeFormat = 'hh:mm a'
        break
      case 'en-GB':
        state.timeFormat = 'HH:mm'
        break
      case 'fr-FR':
        state.timeFormat = 'HH:mm'
        break
      case 'it-IT':
        state.timeFormat = 'HH:mm'
        break
      case 'es-ES':
        state.timeFormat = 'HH:mm'
        break
      case 'pl-PL':
        state.timeFormat = 'HH:mm'
        break
      default:
        state.timeFormat = 'HH:mm'
    }
  },
  updateCurrency: (state, locale) => {
    switch (locale) {
      case 'en-US':
        state.currency = '$'
        break
      case 'en-GB':
        state.currency = '£'
        break
      case 'fr-FR':
        state.currency = '€'
        break
      case 'it-IT':
        state.currency = '€'
        break
      case 'es-ES':
        state.currency = '€'
        break
      case 'pl-PL':
        state.currency = 'zł'
        break
      default:
        state.currency = '€'
    }
  }
}

const actions = {
  setLocale: ({ commit }) => {
    commit('setLocale')
  },
  updateLocale: ({ commit }, locale) => {
    commit('updateLocale', locale)
  },
  updateLocaleMessages: ({ commit }, localeMessages) => {
    commit('updateLocaleMessages', localeMessages)
  },
  updateDateFormat: ({ commit }, locale) => {
    commit('updateDateFormat', locale)
  },
  updateCurrency: ({ commit }, locale) => {
    commit('updateCurrency', locale)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
